import { BillingAddonCode, PaywallPopupReason } from '@nx-frontend/shared/types';

export function mapReasonToAddon(reason: PaywallPopupReason) {
  const reasonToAddon: Partial<Record<PaywallPopupReason, BillingAddonCode>> = {
    [PaywallPopupReason.TRANSCRIBE]: BillingAddonCode.TRANSCRIBE,
    [PaywallPopupReason.AUTOMATION]: BillingAddonCode.AUTOMATION,
    [PaywallPopupReason.AI_ASSISTANT]: BillingAddonCode.AI_ASSISTANT,
    [PaywallPopupReason.AI_LIMIT]: BillingAddonCode.AI,
    [PaywallPopupReason.PORTAL]: BillingAddonCode.PORTALS,
  };
  return reasonToAddon[reason] ?? undefined;
}
